module.exports = __webpack_public_path__ + "static/media/Volna4k-Edit.7cce75c3.png";